import { Button, Callout } from '@expressable/syntax-ds';
import { t } from 'i18next';
import { FC } from 'react';

type Props = {
  onClickLogin: () => void;
};

export const SignupEmailErrorCallout: FC<Props> = ({ onClickLogin }) => {
  return (
    <Callout type="warning">
      {t('directSignup.serverErrors.EMAIL_EXISTS.callout.1')}

      <Button onClick={onClickLogin} variant="link" size="md">
        {t('directSignup.serverErrors.EMAIL_EXISTS.callout.2')}
      </Button>
    </Callout>
  );
};
